// Las dos opciones del final del recorrido se muestran con el recorrido completo, sin elección hecha y sin nada en curso en el chat.
export const proximosPasosAMostrar = ({ miObra, ocupado = false, elegidoLocal = false } = {}) => {
  if (ocupado || elegidoLocal || !miObra?.onboarding?.completo) return null;
  const bloque = miObra.proximos_pasos;
  if (!bloque || bloque.elegido || !Array.isArray(bloque.opciones) || bloque.opciones.length === 0) return null;
  return bloque.opciones;
};
